export const GITHUB_URL = process.env.REACT_APP_GITHUB_URL || '';
